import { useEffect, useState } from 'react'
import DashboardLayout from '../../layoutcontainers/DashboardLayout'
import { Box, Card, CardContent, Chip, Typography } from '@mui/material';
import MaterialTypography from '../../components/MaterialTypography';
import MaterialBox from '../../components/MaterialBox';
import soon from '../../assest/images/project_management.png'
import { AccessTime } from '@mui/icons-material';

const Dashboard = () => {

  const userDetails = JSON.parse(sessionStorage.getItem("user"));
  const [time, setTime] = useState(new Date());

  // Live clock
  useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formattedTime = time.toLocaleTimeString();
  const formattedDate = time.toLocaleDateString(undefined, {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <DashboardLayout>
      {/* <MaterialBox sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                // height: '100vh', 
            }}>
                <img src={soon} alt='image not found' style={{ width: '400px', height: '400px' }} />
                <MaterialTypography variant='h2' color='dark' fontWeight='bold' sx={{ fontStyle: 'italic', fontFamily: '"Dancing Script", cursive' }}> Under Development...</MaterialTypography>
                <MaterialTypography variant='caption' color='text'>We're working hard to bring this page to life. Please check back soon.</MaterialTypography>
            </MaterialBox> */}
      <Card
        sx={{
          mx: { xs: 0, sm: 1 },
          borderRadius: 4,
          p: { xs: 2, sm: 2.5 },
          minHeight: { xs: 200, sm: 170 },
          position: "relative",
          overflow: "hidden",
          background: "linear-gradient(135deg, #3F5AA3 0%, #2A4584 100%)",
          color: "#fff",
          boxShadow: "0 12px 35px rgba(0,0,0,0.18)",
          display: "flex",
          alignItems: "center",

          // softer glow for mobile
          "&::after": {
            content: '""',
            position: "absolute",
            width: { xs: 140, sm: 220 },
            height: { xs: 140, sm: 220 },
            background: "rgba(255,255,255,0.08)",
            borderRadius: "50%",
            top: { xs: -50, sm: -80 },
            right: { xs: -40, sm: -60 },
          },
        }}
      >
        {/* TIME BADGE */}
        <Box
          sx={{
            position: { xs: "relative", sm: "absolute" },
            top: { sm: 18 },
            right: { sm: 18 },
            mt: { xs: 2, sm: 0 },
            alignSelf: { xs: "flex-start", sm: "auto" },
            backdropFilter: "blur(10px)",
            background: "rgba(255,255,255,0.15)",
            borderRadius: 3,
            px: 1.5,
            py: 0.6,
            display: "flex",
            alignItems: "center",
            gap: 0.8,
            width: "fit-content",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          }}
        >
          <AccessTime sx={{ fontSize: 18 }} />
          <Typography variant="body2" fontWeight={600}>
            {formattedTime}
          </Typography>
        </Box>

        <CardContent
          sx={{
            width: "100%",
            p: "0 !important",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          {/* Welcome */}
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: { xs: "18px", sm: "22px", md: "24px" },
              pr: { sm: 10 }, // prevents text under the clock
            }}
          >
            Welcome, {userDetails?.first_name + ' ' + userDetails?.last_name || "Unknown User"}👋
          </Typography>
          {!userDetails?.first_name && (
            <Typography
            sx={{
              opacity: 0.9,
              mt: 0.8,
              fontSize: { xs: "9px", sm: "11px" },
            }}
          >
            Kindly Logout or Update your name in the Portal
          </Typography>
          )}
          <Typography
            sx={{
              opacity: 0.9,
              mt: 0.8,
              fontSize: { xs: "13px", sm: "14px" },
            }}
          >
            Hope you have an Amazing day!
          </Typography>

          {/* Date */}
          <Box mt={2.5}>
            <Chip
              label={formattedDate}
              sx={{
                background: "rgba(255,255,255,0.18)",
                color: "#fff",
                fontWeight: 500,
                backdropFilter: "blur(6px)",
                maxWidth: "100%",
                cursor: "pointer",
                "& .MuiChip-label": {
                  px: 1.5,
                  whiteSpace: "normal", // IMPORTANT for mobile
                  textAlign: "center",
                },
              }}
            />
          </Box>
        </CardContent>
      </Card>
    </DashboardLayout>
  )
}

export default Dashboard
